var baseUrl = process.env.VUE_APP_BASE_URL;
import axios from "axios";
import CreateToken from "./CreateToken";
import GetPostCodeDetails from "./GetPostCodeDetails";
import utils from "@/utilities/utils.js";
import MESSAGE from "@/constants.js";
axios.defaults.headers.common = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Headers":
    "Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type"
};
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (!error.response) {
      return "";
    } else if (error.response.status === 500) {
      return MESSAGE.INVALID_POST;
    } else {
      return MESSAGE.INVALID_POST;
    }
  }
);
class CavesServices {

  // Creates the token and return the token
  async getEndpointForCreateToken(url, params) {
    const serverUrl = baseUrl+url;
    const response = CreateToken.postForToken(serverUrl, params);
    return response;
  }

  // Get response for post code enter and also return w3w
  async getEndpointForAddress(url, params, fileds) {
    const serverUrl = baseUrl + url + params + fileds;
    const token = utils.getCookies();
    const response = GetPostCodeDetails.addressListFromPostCode(serverUrl,token);
    return response;
  }

  // Get response for WeatherInfo
  async getEndpointForWeatherInfo(cityName) {
    const serverUrl = baseUrl+"city/"+cityName+"/OpenWeatherMaps";
    const token = utils.getCookies();
    var response = await axios.get(serverUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
}
export default new CavesServices();
